import styled from 'styled-components';

export const Container = styled.div`
  min-width : 177px;
  padding : 30px;
`;
export const Title = styled.div`
  font-weight : bold;
  font-size : 16px;
  margin-bottom : 30px;
`;

export const Item = styled.div`
display : flex;
font-size : 14px;
padding : 15px ;
:hover{
    cursor: pointer;
    text-decoration : underline;
}
 img{
     max-width : 18px;
     margin-right : 15px;
 }
`;